import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../../../environments/environment';
import { PaginatedList, AppResult, BaseLookupModel } from '../../../models';
import { ChangePasswordModel, UserModel, GetUsersModel, CreateUserModel, UpdateUserModel } from '../../../models/auths';


const IT_API_URL = `${environment.apiUrl}/api/Users`;

@Injectable({
   providedIn: 'root',
})
export class UserHTTPService {
   constructor(private readonly http: HttpClient) { }

   // public methods
   Search(model: GetUsersModel): Observable<PaginatedList<UserModel>> {
      const httpOptions = {
         headers: { 'Content-Type': 'application/json' },
         params: {
            asc: model.asc,
            orderby: model.orderby ?? '',
            page: model.page,
            pageSize: model.pageSize,
            search: model.search ?? '',
            jobId: model.jobId,
            companyId: model.companyId,
            branchId: model.branchId,
            status: model.status,
            roleName: model.roleName ?? ''
         }
      };
      return this.http.get<PaginatedList<UserModel>>(`${IT_API_URL}`, httpOptions);
   }

   GetUser(userName: string): Observable<UserModel> {
      return this.http.get<UserModel>(`${IT_API_URL}/${userName}`);
   }

   Lookup(search: string, companyId: number, branchId: number): Observable<BaseLookupModel[]> {
      const httpOptions = {
         headers: { 'Content-Type': 'application/json' },
         params: {
            search: search,
            companyId: companyId,
            branchId: branchId
         }
      };
      return this.http.get<BaseLookupModel[]>(`${IT_API_URL}/Lookup?search`, httpOptions);
   }

   AddUser(model: CreateUserModel): Observable<AppResult<UserModel>> {
      return this.http.post<AppResult<UserModel>>(`${IT_API_URL}`, model);
   }

   UpdateUser(model: UpdateUserModel): Observable<AppResult<UserModel>> {
      return this.http.put<AppResult<UserModel>>(`${IT_API_URL}`, model);
   }

   SuspendUser(userName: string): Observable<AppResult<UserModel>> {
      return this.http.put<AppResult<UserModel>>(`${IT_API_URL}/Suspend/${userName}`, { userName });
   }

   ActivateUser(userName: string): Observable<AppResult<UserModel>> {
      return this.http.put<AppResult<UserModel>>(`${IT_API_URL}/Activate/${userName}`, { userName });
   }

   ChangePassword(model: ChangePasswordModel): Observable<AppResult<string>> {
      return this.http.post<AppResult<string>>(`${IT_API_URL}/ChangePassword`, model);
   }
}
